import React from "react";
import Header from "./header/Header";

type Props = {
  children: React.ReactNode;
};
export const PageLayout = ({ children }: Props) => {
  return (
    <div className="">
      <Header />
      {children}
    </div>
  );
};
